import { useMemo } from 'react';
import { useWearableConnections } from './use-wearable-connections';
import { WearableTokenManager } from '@/lib/wearables/wearable-token-manager';

/**
 * Hook to check if there are any healthy wearable connections
 * A connection is considered healthy if:
 * 1. Token is not expired
 * 2. token_health_status is 'healthy'  
 * 3. refresh_failure_count is less than 3
 */
export const useHealthyWearableConnections = () => {
  const { data: connections, isLoading, error } = useWearableConnections();

  const healthyConnections = useMemo(() => {
    if (!connections || connections.length === 0) {
      return [];
    }

    return connections.filter(connection => {
      const isExpired = WearableTokenManager.isExpired(connection.expires_at);
      const hasHealthyStatus = connection.token_health_status === 'healthy';
      const hasLowFailureCount = (connection.refresh_failure_count || 0) < 3;
      
      return !isExpired && hasHealthyStatus && hasLowFailureCount;
    });
  }, [connections]);

  const hasHealthyConnection = healthyConnections.length > 0;

  return {
    healthyConnections,
    hasHealthyConnection,
    isLoading,
    error,
    totalConnections: connections?.length || 0
  };
};
